export function redirectUser(id, path) {
    switch (id) {
        case 1:
            return `/admin/${path}`;
        case 2:
            return `/consultor/${path}`;
        case 3:
            return `/empresa/${path}`;
        case 4:
            return `/coordenador/${path}`;
        case 5:
            return `/supervisor/${path}`;
        case 9:
            return `/admin_consultoria/${path}`;

        default:
            return `/${id}`;
    }
}
